import { Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { CategoryModel } from '../../../core/models/category.model';

@Component({
  selector: 'app-category-tile',
  standalone: true,
  imports: [RouterLink],
  templateUrl: './category-tile.component.html',
  styleUrl: './category-tile.component.scss'
})
export class CategoryTileComponent {
  @Input() c!: CategoryModel;
}
